import React from 'react';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';
import { imageUrl } from '../../utils/assets';

interface ConsultationCardProps {
  doctorName: string;
  date: string;
  time: string;
  photoUrl: string;
}

const ConsultationCard: React.FC<ConsultationCardProps> = ({
  doctorName,
  date,
  time,
  photoUrl
}) => {
  return (
    <div className="flex items-center border border-gray-500 rounded-xl p-3 mb-4">
      <img
        src={imageUrl(photoUrl)}
        alt={doctorName}
        className="w-16 h-16 rounded-full object-cover mr-4"
      />
      <div className="flex flex-col">
        <p className="text-gray-600 font-semibold">Konsultasi dengan {doctorName}</p>
        <div className="flex items-center text-sm text-gray-600 mt-1">
          <FaCalendarAlt className="mr-2 text-gray-500" />
          {date}
        </div>
        <div className="flex items-center text-sm text-gray-600 mt-1">
          <FaClock className="mr-2 text-gray-500" />
          {time} WIB
        </div>
      </div>
    </div>
  );
};

export default ConsultationCard;
